import { computed, Injectable, signal } from "@angular/core";
import { AuditStateModel } from "../Dto/AuditStateModel";
import { AuditWithSession, PaginationInfo } from "../Dto/AuditModel";
import { SearchAuditRequest } from "../Dto/SearchAuditRequest";

const initialState: AuditStateModel = {
  audits: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 1,
  },
  searchParams: {
    page: 1,
    limit: 10,
  },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class AuditState {
  private readonly state = signal<AuditStateModel>(initialState);

  public readonly audits = computed(() => this.state().audits);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);

  setAudits(data: AuditWithSession[], pagination: PaginationInfo): void {
    this.state.update((currentState) => ({
      ...currentState,
      audits: data,
      pagination,
      loading: false,
      error: null,
    }));
  }

  setSearchParams(params: SearchAuditRequest): void {
    this.state.update((currentState) => ({
      ...currentState,
      searchParams: params,
    }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  addAudit(audit: AuditWithSession): void {
    this.state.update((currentState) => ({
      ...currentState,
      audits: [audit, ...currentState.audits],
      pagination: {
        ...currentState.pagination,
        total: currentState.pagination.total + 1,
        pages: Math.ceil((currentState.pagination.total + 1) / currentState.pagination.limit),
      },
      loading: false,
      error: null,
    }));
  }

  removeAudit(auditId: string): void {
    this.state.update((currentState) => ({
      ...currentState,
      audits: currentState.audits.filter((audit) => audit.id !== auditId),
      pagination: {
        ...currentState.pagination,
        total: currentState.pagination.total - 1,
        pages: Math.ceil((currentState.pagination.total - 1) / currentState.pagination.limit),
      },
    }));
  }
}
